import React from 'react';

import { Card, Heading } from '../../shared/ui';

import { DocumentActions } from './document-actions';

import { DemoBanner } from './DemoBanner';

export function TreatmentPlan() {
  return (
    <Card radius="control">
      <DemoBanner section="План терапии" />

      <div className="flex items-center justify-between mb-5 pb-4 border-b border-surface-muted">
        <Heading size="lg" as="h3">
          План терапии
        </Heading>
        <DocumentActions />
      </div>

      <div className="space-y-6 text-ui text-ink-muted">
        <section>
          <Heading size="xs" as="h4" className="mb-2">
            Диагноз
          </Heading>
          <p>F43.23 — Расстройство адаптации со смешанной тревогой и депрессивным настроением</p>
        </section>

        <section>
          <Heading size="xs" as="h4" className="mb-3">
            Долгосрочные цели терапии
          </Heading>
          <div className="space-y-3">
            {[
              {
                goal: 'Снижение тревоги',
                desc: 'Клиент научится управлять симптомами тревоги с использованием поведенческих техник',
              },
              {
                goal: 'Самосострадание',
                desc: 'Развитие здорового внутреннего диалога и снижение самокритики',
              },
              {
                goal: 'Границы',
                desc: 'Улучшение способности устанавливать и удерживать здоровые личные и профессиональные границы',
              },
            ].map((item, i) => (
              <div key={i} className="border border-surface-muted rounded-control p-4">
                <p className="font-medium text-ink mb-1">{item.goal}</p>
                <p className="text-ink-muted">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section>
          <Heading size="xs" as="h4" className="mb-3">
            Терапевтические методы
          </Heading>
          <ul className="space-y-2">
            {[
              'Когнитивно-поведенческая терапия (КПТ)',
              'Техники осознанности и майндфулнесс',
              'Телесно-ориентированные практики',
              'Работа с внутренним критиком',
              'Техники регуляции эмоций',
            ].map((m, i) => (
              <li key={i} className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary shrink-0" />
                {m}
              </li>
            ))}
          </ul>
        </section>

        <section>
          <Heading size="xs" as="h4" className="mb-2">
            Частота встреч
          </Heading>
          <p>1 раз в неделю, сессии по 50 минут. Пересмотр плана через 12 сессий.</p>
        </section>

        <section>
          <Heading size="xs" as="h4" className="mb-2">
            Показания к завершению терапии
          </Heading>
          <ul className="space-y-1">
            <li className="flex items-start gap-2">
              <span className="text-ink-subtle mt-0.5">•</span>
              <span>Стабильное снижение тревоги по самооценке клиента</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-ink-subtle mt-0.5">•</span>
              <span>Формирование устойчивых стратегий самопомощи</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-ink-subtle mt-0.5">•</span>
              <span>Способность устанавливать границы без чрезмерной вины</span>
            </li>
          </ul>
        </section>
      </div>
    </Card>
  );
}
